import { Sprout, HandHeart, Crown, Heart, Star, ShieldCheck, Sunrise, Award, Lock } from "lucide-react";

const ICONS = { sprout: Sprout, "hand-heart": HandHeart, crown: Crown, heart: Heart, hearts: Heart, star: Star, "shield-check": ShieldCheck, sunrise: Sunrise };
const COLORS = {
  first_job: "bg-[#E8F4F1] text-[#1F5F4F] border-[#B5DBD1]", ten_jobs: "bg-[#E8F4F1] text-[#1F5F4F] border-[#B5DBD1]",
  fifty_jobs: "bg-[#FFF7E6] text-[#8A5A00] border-[#F1D9A3]", first_thanks: "bg-[#FBEBE4] text-[#9E3F1C] border-[#F3C9B1]",
  ten_thanks: "bg-[#FBEBE4] text-[#9E3F1C] border-[#F3C9B1]", five_star_month: "bg-[#FFF7E6] text-[#8A5A00] border-[#F1D9A3]",
  verified: "bg-[#E8F4F1] text-[#1F5F4F] border-[#B5DBD1]", early_bird: "bg-[#F1ECFA] text-[#5B3FA0] border-[#CFC2EA]",
};

export default function BadgesWall({ badges = [] }) {
  if (!badges.length) return null;
  const earned = badges.filter((b) => b.earned).length;
  return (
    <section data-testid="badges-wall" className="mt-10">
      <div className="flex items-center gap-2 mb-1"><Award className="w-6 h-6 text-[#D99B26]" /><h2 className="text-2xl font-display font-bold text-slate-900">Milestone badges</h2></div>
      <p className="text-slate-600 mb-4">{earned} of {badges.length} earned</p>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
        {badges.map((b) => {
          const Icon = ICONS[b.icon] || Award;
          const progressLabel = b.key === "five_star_month" && !b.earned ? "Keep collecting 5-star reviews" : `${b.progress}/${b.target}`;
          return (
            <div key={b.key} data-testid={`badge-${b.key}-${b.earned ? "earned" : "locked"}`} title={b.description}
              className={`rounded-2xl border-2 p-4 text-center transition-all ${b.earned ? `${COLORS[b.key]} shadow-sm` : "bg-white border-[#E2D9CE] text-slate-400"}`}>
              <div className="relative inline-block">
                <span className={`w-14 h-14 rounded-full flex items-center justify-center mx-auto ${b.earned ? "bg-white/70" : "bg-slate-100"}`}>
                  <Icon className="w-7 h-7" fill={b.earned && ["heart", "hearts", "star"].includes(b.icon) ? "currentColor" : "none"} />
                </span>
                {!b.earned && <Lock className="w-4 h-4 absolute -bottom-0.5 -right-0.5 text-slate-400" />}
              </div>
              <p className={`font-semibold mt-2 ${b.earned ? "" : "text-slate-600"}`}>{b.title}</p>
              <p className="text-xs mt-1 leading-snug">{b.earned ? b.description : progressLabel}</p>
              {!b.earned && b.key !== "five_star_month" && (
                <div className="h-2 rounded-full bg-slate-100 mt-2 overflow-hidden"><div className="h-full bg-[#2E7D6B]/60 rounded-full" style={{ width: `${Math.round((b.progress / b.target) * 100)}%` }} /></div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}
